import { Pipe, PipeTransform } from '@angular/core';
import { IProcessReportBookingItem } from "libraries/interfaces/process-report/i-process-report-response";


@Pipe({
    name: 'computeProcessBookingLink'
})

export class ComputeProcessBookingLinkPipe implements PipeTransform {
    public transform(booking: IProcessReportBookingItem): any {
        return `../../booking/${booking.syscode || booking.code}`;
    }
}
